import type { DashboardExperienceOrderResponse } from '@library/api-dashboard-experience'

type OrderStateLike = Pick<DashboardExperienceOrderResponse, 'state' | 'state_title'>

export const SKIP_ORDER_STATE_TITLE = 'Skipped'

export const isSkipOrder = ({ state, state_title }: OrderStateLike) => {
  const lowerCasedOrderStateTitle = state_title.toLowerCase()

  return (
    state === 'cancelled' ||
    lowerCasedOrderStateTitle.includes('cancelled') ||
    lowerCasedOrderStateTitle.includes('skipped')
  )
}

export const getDisplayedStateTitle = (order: OrderStateLike) => {
  if (order.state === 'premenu') {
    return 'Scheduled'
  }

  if (isSkipOrder(order)) {
    return SKIP_ORDER_STATE_TITLE
  }

  return order.state_title
}
